goog.provide("shadow.js.shim.module$$mui$material$Stepper$default");
shadow.js.shim.module$$mui$material$Stepper$default = shadow.js.shim.module$$mui$material$Stepper.default;
